import { ArrowUp, ExternalLink, Mail } from 'lucide-react'
import { useLocale } from '../context/LocaleContext'

interface FooterProps { onNavigate: (id: string) => void }

export function Footer({ onNavigate }: FooterProps) {
  const { content } = useLocale()
  const { ui } = content
  return (
    <footer className="footer section-shell" id="contact">
      <p className="eyebrow">{ui.contactEyebrow}</p>
      <div className="contact-links">
        <a href="mailto:contact@antonkogan.com"><Mail />contact@antonkogan.com</a>
        <a href="https://www.linkedin.com/in/anton-kogan-developer/" target="_blank" rel="noreferrer"><ExternalLink />{ui.linkedin}</a>
      </div>
      <div className="footer-meta"><span>© {new Date().getFullYear()} Anton Kogan</span><button onClick={() => onNavigate('top')} aria-label={ui.backToTop}><ArrowUp /></button></div>
    </footer>
  )
}
